import React from "react";
import { Dialog, DialogTitle } from "@material-ui/core";
import { SecuritySettingsDisplay } from "./SecuritySettingsDisplay";
import { TokenResultDisplay } from "./TokenResultDisplay";
import ISkywardIntegrationTokenPair from "../../../../models/ISkywardIntegrationTokenPair";

export interface ISettingsDialogProps {
  token: string;
  showDialog: boolean;
  id: number;
  onClose: () => void;
}

export const SecuritySettingsDialog = (props: ISettingsDialogProps): JSX.Element => {
  const { token, showDialog, id, onClose } = props;
  const [tokenResult, setTokenResult] = React.useState<ISkywardIntegrationTokenPair>({ SkywardIntegrationToken1: null, SkywardIntegrationToken2: null });

  const handleClose = () => {
    setTokenResult({ SkywardIntegrationToken1: null, SkywardIntegrationToken2: null });
    onClose();
  };

  const hasTokenResult = tokenResult.SkywardIntegrationToken1 !== null || tokenResult.SkywardIntegrationToken2 !== null;

  return (
    <Dialog open={showDialog}>
      <DialogTitle>Security Settings</DialogTitle>
      {hasTokenResult ? (
        <TokenResultDisplay tokenPair={tokenResult} onClose={handleClose} />
      ) : (
        <SecuritySettingsDisplay token={token} id={id} onClose={handleClose} onSetTokenResult={setTokenResult} />
      )}
    </Dialog>
  );
};
